var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWhatsapp = function SvgIconWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.485 16.945c-.289.819-1.439 1.496-2.355 1.694-.628.134-1.446.239-4.204-.904-3.097-1.283-7.398-5.854-7.398-8.896 0-1.548.893-3.351 2.454-3.351.751 0 .917.015 1.164.608.29.698.995 2.42 1.079 2.596.347.724-.353 1.147-.86 1.777-.163.19-.346.395-.141.748.204.346.91 1.496 1.946 2.419 1.34 1.193 2.426 1.574 2.814 1.736.29.12.635.092.846-.133.268-.29.6-.77.939-1.243.239-.338.542-.38.86-.26.215.074 2.945 1.342 3.06 1.545.085.147.085.846-.204 1.664M12.502 0h-.006C5.881 0 .5 5.382.5 12c0 2.624.846 5.058 2.285 7.033L1.29 23.492 5.9 22.018A11.9 11.9 0 0 0 12.502 24C19.118 24 24.5 18.618 24.5 12S19.118 0 12.502 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconWhatsapp;